import {
  Component,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
    selector: 'app-dashboard-no-results-projects',
    templateUrl: './no-results-projects.component.html',
    styleUrls: ['./no-results-projects.component.scss'],
    standalone: false
})
export class NoResultsProjectsComponent {
  @Input() public canCreateProjects: boolean;
  @Output() public back = new EventEmitter<void>();

  @ViewChild('projectlimit', { static: false })
  public projectlimitOP: OverlayPanel;

  public constructor(private router: Router) {}
  public newProject(): void {
    if (this.canCreateProjects) {
      this.router.navigate(['projects', 'sourcing-creation'], {
        queryParams: { isSourcing: true }
      });
    } else {
      //popover
      this.projectlimitOP.toggle(event);
    }
  }

  public onBack(): void {
    this.back.emit();
  }
}
